import React from 'react'
import {useSelector} from 'react-redux'
import {getIsNoDatesSearch} from 'modules/search/selectors'

import {RoomsDetailOverlayDatefull} from './RoomsDetailOverlayDatefull'
import {RoomsDetailOverlayDateless} from './RoomsDetailOverlayDateless'

/**
 * Both overlays read the same `roomDetailOverlay` state but get their room from
 * different sources: the dateless one from the hotel's static room list, the
 * datefull one from the offers response. Only one is mounted at a time so the
 * inactive variant doesn't run its selectors and tracking.
 */
export const RoomsDetailOverlayContainer = () => {
  const isNoDatesSearch = useSelector(getIsNoDatesSearch)

  return isNoDatesSearch ? (
    <RoomsDetailOverlayDateless />
  ) : (
    <RoomsDetailOverlayDatefull />
  )
}
